var RunSpan, Span, assert, ref, shallowObjectEqual, validateAttributes,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

ref = require('../util'), assert = ref.assert, shallowObjectEqual = ref.shallowObjectEqual;

Span = require('../span-buffer/span');

validateAttributes = function(attributes) {
  var attribute, results, value;
  results = [];
  for (attribute in attributes) {
    value = attributes[attribute];
    assert(typeof attribute === 'string', "Expected " + attribute + " to be string");
    if (value) {
      if (_.isObject(value)) {
        results.push((function() {
          var results1;
          results1 = [];
          for (attribute in value) {
            value = value[attribute];
            assert(typeof attribute === 'string', "Expected " + attribute + " to be string");
            results1.push(assert(typeof value === 'string', "Expected " + value + " to be string"));
          }
          return results1;
        })());
      } else {
        results.push(assert(typeof value === 'string', "Expected " + value + " to be string"));
      }
    } else {
      results.push(void 0);
    }
  }
  return results;
};

RunSpan = (function(superClass) {
  extend(RunSpan, superClass);

  RunSpan.attributes = null;

  function RunSpan(text, attributes1) {
    this.attributes = attributes1 != null ? attributes1 : {};
    RunSpan.__super__.constructor.call(this, text);
  }

  RunSpan.prototype.clone = function() {
    var clone;
    clone = RunSpan.__super__.clone.call(this);
    clone.attributes = Object.assign({}, this.attributes);
    return clone;
  };


  /*
  tagName: null
  Object.defineProperty @::, 'tagName',
    get: -> 'run'
   */

  RunSpan.prototype.setAttributes = function(attributes) {
    if (attributes == null) {
      attributes = {};
    }
    return this.attributes = Object.assign({}, attributes);
  };

  RunSpan.prototype.addAttribute = function(attribute, value) {
    return this.attributes[attribute] = value;
  };

  RunSpan.prototype.addAttributes = function(attributes) {
    var k, results, v;
    results = [];
    for (k in attributes) {
      v = attributes[k];
      results.push(this.attributes[k] = v);
    }
    return results;
  };

  RunSpan.prototype.removeAttribute = function(attribute) {
    return delete this.attributes[attribute];
  };

  RunSpan.prototype.mergeWithSpan = function(run) {
    if (shallowObjectEqual(this.attributes, run.attributes)) {
      this.setString(this.string + run.string);
      return true;
    } else {
      return false;
    }
  };

  RunSpan.prototype.toString = function() {
    var name, nameValues, sortedNames;
    sortedNames = (function() {
      var results;
      results = [];
      for (name in this.attributes) {
        results.push(name);
      }
      return results;
    }).call(this);
    sortedNames.sort();
    nameValues = (function() {
      var i, len, results;
      results = [];
      for (i = 0, len = sortedNames.length; i < len; i++) {
        name = sortedNames[i];
        results.push(name + ":" + (JSON.stringify(this.attributes[name])));
      }
      return results;
    }).call(this);
    return RunSpan.__super__.toString.call(this, nameValues.join('/'));
  };

  return RunSpan;

})(Span);

module.exports = RunSpan;



/*****************
 ** WEBPACK FOOTER
 ** ./lib/run-buffer/run-span.js
 ** module id = 17
 ** module chunks = 0
 **/